import React from "react";
import { Link } from "react-router-dom";

import pro1 from "../../assets/images/product-1.png"
import pro2 from "../../assets/images/product-2.png"
import pro3 from "../../assets/images/product-3.png"
import pro4 from "../../assets/images/product-4.png"
import pro5 from "../../assets/images/product-5.png"

const ProductlistMostselling = () => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div className="col-span-12 gap-6 p-5 bg-white border rounded 2xl:col-span-9 dark:bg-darklight dark:border-darkborder border-black/10">
          <div className="flex items-center gap-3 mb-4">
            <h2 className="text-base font-semibold text-black capitalize dark:text-white/80 grow">
              Products List
            </h2>
            <Link
              to="#"
              className="px-3 py-1.5 rounded-md text-xs border border-black/20 dark:border-darkborder text-muted"
            >
              <i className="align-bottom ltr:mr-1 rtl:ml-1 ri-filter-line"></i>{" "}
              Filters
            </Link>
          </div>
          <div className="overflow-auto">
            <table className="min-w-[640px] w-full">
              <thead>
                <tr className="ltr:text-left rtl:text-right">
                  <th>Product Name</th>
                  <th>Categories</th>
                  <th>Total Sales</th>
                  <th>Stock</th>
                  <th>Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      wireless cyberpunk headphones
                    </Link>
                  </td>
                  <td>Headphones</td>
                  <td>2952</td>
                  <td>258</td>
                  <td>$49.65</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      green front sweater
                    </Link>
                  </td>
                  <td>Fashion</td>
                  <td>2341</td>
                  <td>140</td>
                  <td>$229.65</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      Isolated white cap
                    </Link>
                  </td>
                  <td>Accessories</td>
                  <td>2792</td>
                  <td>654</td>
                  <td>$39.47</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      white tote bag
                    </Link>
                  </td>
                  <td>Bag</td>
                  <td>1765</td>
                  <td>265</td>
                  <td>$87.99</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      Running orange shoes
                    </Link>
                  </td>
                  <td>Shoes</td>
                  <td>2268</td>
                  <td>322</td>
                  <td>$156.41</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>
                    <Link to="#!" className="capitalize">
                      Stylish golden watch
                    </Link>
                  </td>
                  <td>Watch</td>
                  <td>3128</td>
                  <td>985</td>
                  <td>$207.00</td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex items-center gap-3 mt-4">
            <p className="text-muted grow">
              Showing <b>05</b> of <b>07</b> Results
            </p>
            <ul className="inline-flex items-center gap-1 shrink-0">
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  First
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  Prev
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  1
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-purple border border-purple"
                >
                  2
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  3
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  Next
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="flex justify-center px-2.5 py-1 rounded transition text-muted hover:text-purple border border-black/10 hover:border-purple dark:border-darkborder dark:text-darkmuted dark:hover:text-purple dark:hover:border-purple"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-span-12 gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10 2xl:col-span-3">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Most Selling Products
          </h2>
          <div className="flex flex-col gap-3">
            <div className="flex gap-2 p-3 bg-gray-100 rounded-md dark:bg-darkborder/50">
              <img
                src={pro1}
                alt=""
                className="size-10 shrink-0"
              />
              <div className="overflow-hidden grow">
                <h6 className="mb-1 text-black capitalize truncate dark:text-white/80">
                  <Link to="#!">Elegance color apparel clothes clothing</Link>
                </h6>
                <ul className="flex items-center gap-3 text-xs text-muted">
                  <li>Sales: 158</li>
                  <li>Fashion</li>
                </ul>
              </div>
              <h6 className="font-bold text-black rtl:float-left ltr:float-right dark:text-white/80">
                $49.99
              </h6>
            </div>
            <div className="flex gap-2 p-3 bg-gray-100 rounded-md dark:bg-darkborder/50">
              <img
                src={pro2}
                alt=""
                className="size-10 shrink-0"
              />
              <div className="overflow-hidden grow">
                <h6 className="mb-1 text-black capitalize truncate dark:text-white/80">
                  <Link to="#!">Graphic tshirt trendy</Link>
                </h6>
                <ul className="flex items-center gap-3 text-xs text-muted">
                  <li>Sales: 264</li>
                  <li>Women Fashion</li>
                </ul>
              </div>
              <h6 className="font-bold text-black rtl:float-left ltr:float-right dark:text-white/80">
                $85.77
              </h6>
            </div>
            <div className="flex gap-2 p-3 bg-gray-100 rounded-md dark:bg-darkborder/50">
              <img
                src={pro3}
                alt=""
                className="size-10 shrink-0"
              />
              <div className="overflow-hidden grow">
                <h6 className="mb-1 text-black capitalize truncate dark:text-white/80">
                  <Link to="#!">Simple Gray t-shirt</Link>
                </h6>
                <ul className="flex items-center gap-3 text-xs text-muted">
                  <li>Sales: 365</li>
                  <li>Fashion</li>
                </ul>
              </div>
              <h6 className="font-bold text-black rtl:float-left ltr:float-right dark:text-white/80">
                $73.22
              </h6>
            </div>
            <div className="flex gap-2 p-3 bg-gray-100 rounded-md dark:bg-darkborder/50">
              <img
                src={pro4}
                alt=""
                className="size-10 shrink-0"
              />
              <div className="overflow-hidden grow">
                <h6 className="mb-1 text-black capitalize truncate dark:text-white/80">
                  <Link to="#!">Modern minimal headphone</Link>
                </h6>
                <ul className="flex items-center gap-3 text-xs text-muted">
                  <li>Sales: 144</li>
                  <li>Headphones</li>
                </ul>
              </div>
              <h6 className="font-bold text-black rtl:float-left ltr:float-right dark:text-white/80">
                $164.20
              </h6>
            </div>
            <div className="flex gap-2 p-3 bg-gray-100 rounded-md dark:bg-darkborder/50">
              <img
                src={pro5}
                alt=""
                className="size-10 shrink-0"
              />
              <div className="overflow-hidden grow">
                <h6 className="mb-1 text-black capitalize truncate dark:text-white/80">
                  <Link to="#!">Top view cap</Link>
                </h6>
                <ul className="flex items-center gap-3 text-xs text-muted">
                  <li>Sales: 648</li>
                  <li>Accessories</li>
                </ul>
              </div>
              <h6 className="font-bold text-black rtl:float-left ltr:float-right dark:text-white/80">
                $99.49
              </h6>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductlistMostselling;
